module.exports = __webpack_public_path__ + "static/media/799CameronMadisonAlexanderBlvdNW_2018-07-09_197.3784607d.jpg";